/**
 * @flow
 * @relayHash 299d48304dedd924f126a250120c3e92
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProfileDonateHeartsContainer_app$ref = any;
type ProfileDonateHeartsContainer_user$ref = any;
export type ProfileDonateHeartsViewQueryVariables = {|
  userId: string
|};
export type ProfileDonateHeartsViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: ProfileDonateHeartsContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: ProfileDonateHeartsContainer_user$ref
  |},
|};
export type ProfileDonateHeartsViewQuery = {|
  variables: ProfileDonateHeartsViewQueryVariables,
  response: ProfileDonateHeartsViewQueryResponse,
|};
*/


/*
query ProfileDonateHeartsViewQuery(
  $userId: String!
) {
  app {
    ...ProfileDonateHeartsContainer_app
    id
  }
  user(userId: $userId) {
    ...ProfileDonateHeartsContainer_user
    id
  }
}

fragment ProfileDonateHeartsContainer_app on App {
  charities(first: 20) {
    edges {
      node {
        id
        ...CharityContainer_charity
      }
    }
  }
}

fragment ProfileDonateHeartsContainer_user on User {
  ...CharityContainer_user
}

fragment CharityContainer_user on User {
  id
  vcCurrent
  ...DonateHeartsControlsContainer_user
}

fragment DonateHeartsControlsContainer_user on User {
  id
  vcCurrent
}

fragment CharityContainer_charity on Charity {
  id
  description
  logo
  name
  website
  ...DonateHeartsControlsContainer_charity
}

fragment DonateHeartsControlsContainer_charity on Charity {
  id
  image
  imageCaption
  impact
  name
  website
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ProfileDonateHeartsViewQuery",
  "id": null,
  "text": "query ProfileDonateHeartsViewQuery(\n  $userId: String!\n) {\n  app {\n    ...ProfileDonateHeartsContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...ProfileDonateHeartsContainer_user\n    id\n  }\n}\n\nfragment ProfileDonateHeartsContainer_app on App {\n  charities(first: 20) {\n    edges {\n      node {\n        id\n        ...CharityContainer_charity\n      }\n    }\n  }\n}\n\nfragment ProfileDonateHeartsContainer_user on User {\n  ...CharityContainer_user\n}\n\nfragment CharityContainer_user on User {\n  id\n  vcCurrent\n  ...DonateHeartsControlsContainer_user\n}\n\nfragment DonateHeartsControlsContainer_user on User {\n  id\n  vcCurrent\n}\n\nfragment CharityContainer_charity on Charity {\n  id\n  description\n  logo\n  name\n  website\n  ...DonateHeartsControlsContainer_charity\n}\n\nfragment DonateHeartsControlsContainer_charity on Charity {\n  id\n  image\n  imageCaption\n  impact\n  name\n  website\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileDonateHeartsViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProfileDonateHeartsContainer_app",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ProfileDonateHeartsContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileDonateHeartsViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "charities",
            "storageKey": "charities(first:20)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 20,
                "type": "Int"
              }
            ],
            "concreteType": "CharityConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CharityEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Charity",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "logo",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "website",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "image",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "imageCaption",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "impact",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcCurrent",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2925300cfd8a9ba6a5bbf039c6d68739';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Profile/__generated__/ProfileDonateHeartsViewQuery.graphql.js